import Modal from "../../../../components/modal"
import PlayerCard from "../PlayerCard"
import GridNumbers from "./components/GridNumbers"
import "./index.css"

const ConfirmPointModal = ({vote, player, cancel, currentPoint, pointAvaible, selectedPoints, 
    selectPoint, selectedPlayers, keyPhase})=>{

    return (
        <Modal>
            <div className="confirm-modal-container">
                <div className="confirm-modal-card-subcontainer" >
                    <p className="confirm-point-title-text">¿Cuantos puntos le vas a dar a este jugador</p>
                    <PlayerCard handleVoteByPlayer={vote} player={player}  />
                    <GridNumbers numbers={pointAvaible} selectedPoints={selectedPoints} selectPoint={selectPoint} currentPoint={currentPoint} />
                    <div className="confirm-modal-point-card-container-buttons">
                        {
                            currentPoint && (
                                <>
                        <button className="btn-confirm-point" onClick={()=>{
                            selectPoint(prev => ({...prev, selectedPoints:[...prev.selectedPoints, currentPoint], playersVoted:[...prev.playersVoted, player]}))
                            cancel()
                            selectPoint(prev => ({...prev, currentPoint:null}))
                            console.log('playeer', player)

                            const votedInfoPlayers ={
                                numberVoted: [...selectedPoints, currentPoint],
                                playersVoted: [...selectedPlayers, player]
                            }

                            vote(player, currentPoint)

                            localStorage.setItem(keyPhase, JSON.stringify(votedInfoPlayers))


                        }}>Confirmar</button>
</>

                            )
                        }
                        <button className="btn-cancel-point" onClick={()=>{
                            cancel()
                            selectPoint(prev => ({...prev, currentPoint:null}))
                        }}>Cancelar</button>
                    </div>

                </div>

            </div>

        </Modal>
    )
}

export default ConfirmPointModal